import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/hooks';
import { Button } from '@/components/ui/button';

export const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className="flex items-center h-8 rounded-full bg-gray-100 dark:bg-gray-800 p-1 gap-1">
            <Button
                variant="ghost"
                size="icon"
                onClick={() => isDark && toggleTheme()}
                className={`
                    w-6 h-6 rounded-full transition-all duration-300 cursor-pointer
                    ${!isDark && "bg-white text-berry-purple shadow-sm"} 
                `}
            >
                <Sun className="h-3.5 w-3.5" />
                <span className="sr-only">Light mode</span>
            </Button>
            <Button
                variant="ghost"
                size="icon"
                onClick={() => !isDark && toggleTheme()}
                className={`
                    w-6 h-6 rounded-full transition-all duration-300 cursor-pointer
                    ${isDark && "bg-gray-700 text-berry-purple shadow-sm"}
                `}
            >
                <Moon className="h-3.5 w-3.5" />
                <span className="sr-only">Dark mode</span>
            </Button>
        </div>
    );
};

export default ThemeToggle;